import { Banner } from '../../../banner/Banner';
import { ConfirmationBodyExtraParams } from '../../../modal/ConfirmModal/ConfirmModal';
import { Integration, PipelineReplicationTypeMode } from '../../../shared/interfaces/integration';

interface EnablePipelineDialogBodyProps
  extends Partial<ConfirmationBodyExtraParams<{ replicationType: string }>> {
  entity: Integration;
}

export function EnablePipelineDialogBody({ entity }: EnablePipelineDialogBodyProps) {
  return (
    <div>
      <div className='text-body-1 text-secondary'>
        If enabled, Hevo will drop the existing Destination tables and start{' '}
        {entity.config.replication_type === PipelineReplicationTypeMode.INCREMENTAL_ONLY
          ? 'incremental'
          : 'historical'}{' '}
        load for all the included objects.
      </div>

      <Banner open dataId='warning' color='warning' icon='warning' className='mt-5'>
        <span className='text-body-1 text-secondary'>
          Enabling a Pipeline may have cost and resource implications for your Source and
          Destination. This additional cost does not affect your Events usage cost, as Hevo does not
          charge you for historical data.
        </span>
      </Banner>
    </div>
  );
}
